export default {
sets: `Sets`,
stats: `Statistieken`,
discover: `Ontdekken`,
guides: `Gidsen`,
settings: `Instellingen`,
unsupportedBrowserBody: `Flashcards ondersteunt deze browser niet. Download de nieuwste versie van Chrome of Opera, of download onze iPhone of Android -applicatie`,
unsupportedBrowserTitle: `Niet-ondersteunde browser`,
noData: `Geen gegevens om aan te tonen`,
contactUsTitle: `We horen graag hoe onze gebruikers onze app gebruiken en hoe we kunnen verbeteren. Stuur ons een bericht met eventuele vragen, zoals functieverzoeken of bugrapporten`,
rateAppStore: `Beoordeel in AppStore`,
rateGoogle: `Beoordeel in Google Play`,
close: `Dichtbij`,
shareFriends: `Delen met vrienden`,
noCardsQ: `Heb je geen flashcards?`,
noCardsS: `Kies uit onze collectie om te beginnen`,
suggestSet: `Stel set voor`,
createOwn: `Maak je eigen`,
search: `Zoekopdracht`,
loading: `Bezig met laden`,
words: `Woorden`,
downloads: `Downloads`,
export: `Exporteren`,
import: `Importeren`,
importing: `Importeren ... sluit de app niet`,
importPreview: `Importeer preview`,
howQuizlet: `Hoe te importeren vanuit Quizlet`,
cards: `Kaarten`,
importPreviewStatus: `__ Voorwaarden zijn klaar om te worden toegevoegd aan de bestaande ___ -kaarten`,
importPaste: `Plak uw kaarten in de bovenstaande tekstrea`,
setTotalLimitReached: `Je kunt slechts 3000 kaarten in een studyset hebben`,
studying: `Aan het studeren`,
learnt: `Geleerd`,
mastered: `Onder de knie`,
new: `Nieuw`,
noTerm: `Geen term`,
noDef: `Geen definitie`,
cardSaved: `Kaart opgeslagen`,
reviews: `Beoordelingen`,
practices: `Handel`,
flashcards: `Flashcards`,
alerts: `Meldingen`,
corrects: `Corrigeren`,
mistakes: `Fouten`,
reviewCycle: `Beoordelingscyclus`,
reviewsLeft: `Recensies links`,
lastReview: `Laatste beoordeling`,
nextReview: `Volgende recensie`,
hideHistory: `Verberg volledige geschiedenis`,
showHistory: `Toon volledige geschiedenis`,
strength: `Kracht`,
star: `Ster`,
image: `Afbeelding`,
tag: `Label`,
added: `toegevoegd`,
removed: `VERWIJDERD`,
reviewedFrom: `Beoordeeld van __`,
notifications: `Meldingen`,
reviewedPractice: `Beoordeeld __ door ___ oefening`,
successfully: `met succes`,
unsuccessfully: `zonder succes`,
termUpdated: `Term bijgewerkt`,
defUpdated: `Definitie bijgewerkt`,
flashcardCreated: `Flashcard gemaakt`,
dropboxImage: `U moet Dropbox Sync inschakelen om afbeeldingen toe te voegen`,
deleteImgConfirm: `Weet u zeker dat u deze afbeelding wilt verwijderen?`,
uploading: `Het uploaden`,
save: `Opslaan`,
uploadImageFail: `Kan de afbeelding niet uploaden`,
imageUploaded: `Afbeelding geüpload`,
setNotFound: `Studyset niet gevonden!`,
notEnoughCards: `Niet genoeg kaarten!`,
of: `__ van ___`,
on: `Op`,
off: `Uit`,
auto: `Automatisch`,
manual: `Handleiding`,
pronounce: `Uitspreken`,
practiceCompleted: `Je hebt deze praktijk voltooid`,
closePractice: `Dicht bij de praktijk`,
autoplay: `Automatisch afspelen`,
secFlipSecNext: `__ sec flip, ___ sec Volgende`,
autopronounce: `Autopronounce`,
onlyTerm: `Alleen termijn`,
onlyDef: `Alleen definitie`,
termAndDef: `Term en definitie`,
savePractice: `Oefening opslaan?`,
continueLater: `Ga later verder`,
deletePractice: `Verwijder de praktijk`,
term: `Termijn`,
def: `Definitie`,
monA: `M`,
tueA: `T`,
wedA: `W`,
thuA: `T`,
friA: `F`,
satA: `S`,
sunA: `S`,
reviewGoal: `Beoorzieningsdoel`,
dailyGoal: `Dagelijks doel`,
edit: `Bewerk`,
setUp: `Opgericht`,
noRecentPractice: `U heeft geen recente praktijken`,
continueLastReview: `Ga door met de laatste beoordeling`,
dueCards: `Gegeven kaarten`,
studyNow: `Studeer nu`,
newCards: `Nieuwe kaarten`,
terms: `voorwaarden`,
defs: `definities`,
validCardsOf: `Alleen __ van de geselecteerde ___ -kaarten kunnen worden toegepast, omdat de anderen de term of de definitie missen`,
reviewCards: `Beoordelingskaarten`,
customizePractice: `Pakt de praktijk aanpassen`,
next: `Volgende`,
iWasRight: `ik had gelijk`,
printProAlert: `Koop een Pro -abonnement om meer dan 20 flashcards af te drukken`,
print: `Afdrukken`,
printWidth: `Term-def breedte`,
printFont: `Lettertypegrootte`,
printBorder: `Grens`,
printMargin: `Paginamarge`,
printPadding: `Woordvulling`,
preparingFile: `Bestand voorbereiden`,
notificationsBlocked: `Meldingen zijn niet ingeschakeld, u schakelt meldingen in van de instellingen van uw telefoon`,
ranOutOfWords: `Raft zonder kaarten, start de praktijk opnieuw om opnieuw te beginnen`,
ranOutOfWordsShort: `Zonder woorden`,
ranOutOfWordsBody: `Open de app om nieuwe woorden te plannen`,
proIncreaseNotifications: `U kunt de totale meldingen verhogen van 10 naar 50 in de premium -versie.`,
schedule: `Planning`,
frequency: `Frequentie`,
mode: `Modus`,
tM1: `1 minuut`,
tM2: `2 minuten`,
tM5: `5 minuten`,
tM10: `10 minuten`,
tM15: `15 minuten`,
tM30: `30 minuten`,
tH1: `1 uur`,
tH2: `twee uur`,
termPassive: `Term passief`,
termActive: `Term actief`,
defPassive: `Zeker passief`,
defActive: `Def actief`,
scheduledIn: `Gepland in __ minuten`,
scheduledAlertsProT: `Verhoog geplande waarschuwingen met pro`,
scheduledAlertsProB: `U kunt de geplande meldingen verhogen van 10 naar 50 met het Pro -pakket`,
seeFeatures: `Zie functies`,
defAndTerm: `Definitie en term`,
termHoldDef: `Term, houd vast om de definitie te onthullen`,
defHoldTerm: `Definitie, houd vast om de term te onthullen`,
notificationType: `Notificatie type`,
copyToClipboard: `Kopieer naar klembord`,
enterAuthCode: `Voer uw autorisatiecode in`,
invalidCode: `Ongeldige code verstrekt`,
copied: `Gekopieerd!`,
promoH2: `FlashCard Manager Pro`,
promoP: `Tik op om alle premium -functies te ontdekken om efficiënter te leren in uw eigen tempo`,
promoBtn: `Ontdek alle functies`,
setDropboxH2: `Dropbox Sync`,
setDropboxPOff: `Schakel Dropbox Sync in om uw sets, flashcards, tags en voortgang geback -up en bijgewerkt op al uw apparaten te houden.`,
setDropboxPOn: `Uw gegevens worden ondersteund en gesynchroniseerd op uw apparaten.`,
setDropboxBtn: `Synchroniseren`,
status: `Toestand`,
syncNow: `Synchroniseer nu`,
contact: `Contact`,
contactUs: `Neem contact op`,
useFromBrowser: `Gebruik vanuit de browser`,
useFromBrowserMsg: `Bezoek flashcardsmadesimple.com op uw computer en herstel uw kaarten en licentie door Dropbox Sync in te schakelen`,
termsPrivacy: `Voorwaarden en privacy`,
dailyReviewGoal: `Dagelijkse beoordelingsdoel`,
numberTerms: `Aantal termen`,
selectTerm: `Selecteer met term hint`,
selectDef: `Selecteer met Definition Hint`,
pronounceTerm: `Spreek uit met term hint`,
pronounceDef: `Spreek uit met definitie hint`,
typeTerm: `Typ met term hint`,
typeDef: `Type met definitie hint`,
quizTypes: `Voorkeursquiztypen`,
spacedRepetition: `Verspreide herhalingsschema`,
spacedRepetitionP: `Met een op elkaar gerichte herhaling kunt u woorden onder de knie krijgen met minder inspanningen door de beoordelingstijd stapsgewijs te versterken. Het standaardschema is 1-3-7-15-31 dagen, maar u kunt ook een aangepaste instellen.`,
spacedRepetionScheduleItem: `__ Dagen na ___ Review (dag ____)`,
atLeastOneSchedule: `Er is ten minste één schema vereist`,
revisionLimitReached: `Je hebt het maximale revsision -aantal bereikt`,
addReviewSchedule: `Voeg nieuw beoordelingsschema toe`,
autoMarkLearnt: `Auto Mark geleerd daarna`,
autoMarkMastered: `Auto Mark beheerst na`,
tagManager: `Tag Manager`,
delete: `Verwijderen`,
addTag: `Voeg een nieuwe tag toe`,
tagDeletionH: `Tag -verwijdering`,
tagDeletionP: `Weet u zeker dat u deze tag wilt verwijderen?`,
cancel: `Annuleren`,
daysAfterLastReview: `Dagen na de laatste beoordeling`,
linkDropbox: `Link Dropbox`,
startSync: `Start synchronisatie`,
starred: `Sterren`,
images: `Afbeeldingen`,
tags: `Tags`,
types: `Soorten`,
activeDays: `Actieve dagen`,
inactiveDays: `Inactieve dagen`,
longestStreak: `Langste streak`,
dailyGoalsCompleted: `Dagelijkse doelen zijn voltooid`,
dailyGoalsFailed: `Dagelijkse doelen zijn mislukt`,
typePairs: `Type paren`,
reviewTypes: `Beoordelingstypen`,
typePractice: `Type oefening`,
pronouncePractice: `Spreek praktijk uit`,
selectPractice: `Selecteer oefenen`,
notificationReview: `Kennisgeving Review`,
flashcardReview: `Flashcard review`,
studyset: `Studyset`,
enterStudysetName: `Voer een naam in voor uw Studyset`,
studysetName: `Voer de naam van de set in`,
termType: `Term Type / Lang`,
defType: `Definitietype / lang`,
exportCards: `Exportkaarten exporteren`,
importCards: `Importkaarten`,
quiz: `Quiz`,
showingOutOfCards: `Tonen __ uit ___ kaarten`,
showingAllCards: `Typ alle kaarten, typ in de bovenstaande zoekbalk of tik op tags om te filteren`,
recording: `Opname`,
downloadSet: `Voeg toe aan mijn sets`,
addNewCard: `Voeg nieuwe kaart toe`,
saveStudyset: `Studieset opslaan`,
studysetDeletionH: `Studyset Deletion`,
studysetDeletionP: `Weet je zeker dat je dit Studyset wilt verwijderen, dit zal ook alle opgenomen kaarten verwijderen.`,
cardDeletionH: `Kaartenverwijdering`,
cardDeletionP: `Weet je zeker dat je deze kaart wilt verwijderen`,
cardLimitReached: `Je kunt slechts 3000 kaarten in een studyset hebben`,
limitExceeded: `Limiet overschreden`,
atLeastTenCards: `Voeg minstens 10 kaarten toe om aan de slag te gaan met de praktijken`,
searchInAll: `Zoek in alle onderzoekssets`,
noMatch: `Geen match`,
atLeastThreeChars: `Voer minimaal 3 tekens in om te zoeken`,
noSets: `Geen sets`,
startingSync: `Startsynchronisatie`,
noSetsP: `Selecteer uit de onderstaande opties om te beginnen`,
startingSyncP: `We halen uw gegevens van Dropbox, dit kan een tijdje duren`,
createNewStudyset: `Maak een nieuw studyset`,
restoreFromBackup: `Herstel van back -upbestand`,
setStarterPacks: `Studyset Starterpacks`,
selectPracticeType: `Selecteer Type oefening`,
noDueCards: `Flashcards die u eerder hebt beoordeeld nog geen flashcards`,
noNewCards: `Geen nieuwe kaarten om te studeren`,
subscriptionH: `Koop pro om te genieten van alle functies en om de continieuze ontwikkeling te ondersteunen.`,
buyLifetimePro: `Koop Lifetime Pro voor __`,
restorePurchase: `HERSTEL AANKOOP`,
termsPrivacyC: `Voorwaarden en privacybeleid`,
licenceShare: `Als u een licentie van een ander apparaat hebt gekocht, kunt u deze met dit apparaat delen door Dropbox Sync in te schakelen op beide apparaten`,
enterTagName: `Voer de naam van de tag in`,
invalidName: `Ongeldige naam`,
create: `Creëren`,
name: `Naam`,
tagName: `Naam van uw tag`,
color: `Kleur`,
back: `Rug`,
rowSeparator: `Rijafscheider`,
termDefSeparator: `Term - Def Separator`,
output: `Uitvoer`,
inputCards: `Invoerkaarten invoeren`,
review: `Beoordeling`,
language: `Taal`,
archiveReversible: `Archief (omkeerbaar van instellingen)`,
deletePermanent: `Verwijderen (onomkeerbaar)`,
archivedCards: `Gearchiveerde kaarten`,
masteredCards: `Beheerste kaarten`,
due: `Vanwege`,
reviewed: `Beoordeeld`,
markReviewed: `Mark Reviewed`,
markMastered: `Mark Mastered`,
forXYCards: `voor __ ___ kaarten`,
createdAtSortBy: `Aanmaakdatum`,
lastReviewedSortBy: `Laatste beoordelingsdatum`,
reviewCountSortBy: `Aantal beoordelingen`,
strengthSortBy: `Kracht`,
termSortBy: `Alfabetische term`,
definitionSortBy: `Alfabetische def.`,
ascSortBy: `Oplopende`,
descSortBy: `Aflopend`,
featureSync: `Bestudeer alles, overal, altijd met uw flashcards gesynchroniseerd op al uw apparaten`,
featureSpacedrepetition: `Kijk naar uw algehele vooruitgang en ga terug naar het oefenen van wat u nodig hebt om te oefenen`,
featureNotifications: `Bekleed uw leren zonder zelfs het openen van de app met flexibele meldingen`,
featureFlashcards: `Autoplay flashcards als je handen of ogen bezig zijn, maar je hebt nog steeds ongebruikte aandacht`,
featureQuiz: `Match, spellen, luisteren of selecteren om uw flashcards te oefenen`,
featureStats: `Krijg beter inzicht in uw kaarten en resultaten en zoek op al uw flashcard -sets`,
featureImport: `We zullen nooit gegevens van u opslaan, en u kunt al uw gegevens eenvoudig exporteren en importeren`,
featurePrint: `Krijg wat leren door je flashcards af te drukken en je eigen studeer -installatie te doen`,
splashIntro: `Bestudeer al je flashcards overal in je tempo en stijl`,
selectSortOrder: `sorteervolgorde`,
selectSortProp: `Sorteer eigenschap`,
applyFilters: `Pas filters toe`,
selectSetType: `Wat wil je oefenen?`,
getStarted: `Begin`,
tapToUnarchive: `Tik op de kaarten die u wilt niet archiveren`,
untitled: `Ongetiteld`,
sortHintNew: `Je zult de kaarten zien die het langst geleden zijn gemaakt`,
sortHintDue: `U zult kaarten zien die eerst het langst moeten zijn`,
sortHintOther: `Je zult kaarten zien die niet de langste eerste zijn bestudeerd`,
flashcardsWhen: `, wanneer je handen of ogen bezig zijn, zelfs tijdens het luisteren naar muziek / podcasts`,
notificationsWhen: `, voor wanneer je op pad bent en gewoon snelstudiebits wilt`,
quizWhen: `, voor wanneer u volle aandacht kunt besteden om te studeren, om uw kaarten te beheersen`,
features: `Functies`,
ratings: `Waarderingen`,
notificationDailyCatchUpBody: `Nieuw: __, verschuldigd: ___, studeren: ____, geleerd: _____, mastered: ______`,
notificationDailyCatchUpTitle: `Dagelijkse inhaalheid`,
reviewedJN: `Zojuist beoordeeld`,
customUpdated: `Aangepaste tekst bijgewerkt`,
customTextField: `Synoniemen, voorbeelden, etc.`,
field: `Veld`,
link: `Koppeling`,
backToParentCard: `Terug naar ouderkaart`,
discard: `Weggooien`,
failedImageLoad: `Zorg ervoor dat u op internet bent aangesloten op het internet niet laden`,
printDIYLabel: `DIY Uw eigen creatieve papieren studieopstelling, deel met ons uw creatie en word te zien in de app.`,
reviewGraphChart: `Bekijk de frequentie`,
langNotSet: `Taal niet ingesteld`,
pronouncationLangInfo: `Om uitspraak mogelijk te maken, moet u de term en definitietaal selecteren. Er verschijnt een sprekerteken naast de talen als uw apparaat die taal ondersteunt`,
clearFilters: `Filter wissen`,
subFreeUnlimited: `Onbeperkt studysets, flashcards, praktijken, zoeken en synchroniseren`,
customFields: `Aangepaste velden`,
subLinks: `Kaartlinks`,
subPrint: `Print / studyset`,
subNotifications: `Kennisgeving voordat u de app moet openen`,
subCardsStudysets: `Kaarten / studyset`,
subRevisionCycles: `Aangepaste revisiecycli`,
subscriptionHEnd: `Upgraden naar PRO laat ons zien dat u ons harde werk waardevol vindt en ons aanmoediging en koffie geeft om te blijven verbeteren en nieuwe geweldige dingen te creëren.`,
subFree: `Vrij`,
subPro: `Pro`,
guideSpacedRepetition: `Hoe werkt de typen van de afstand van elkaar`,
guideSearch: `Zoeken en filteren`,
guideSync: `Schakel back -up in en synchroniseer op uw apparaten`,
guidePronunciation: `Schakel uitspraak in`,
guideImport: `Kaarten importeren van het verlaten van bronnen`,
guideAccess: `Wie heeft toegang tot mijn gegevens?`,
guideData: `Welke gegevens verzamelen we?`,
guideContact: `Hulp nodig met iets anders? Schrijf ons`,
arrowStrength: `Stel in hoe goed je deze kaart kent`,
arrowImage: `Voeg afbeeldingen toe`,
arrowField: `Voeg extra aangepaste tekstvelden toe`,
arrowTag: `Voeg tags toe`,
arrowStar: `Markeer als favoriet`,
arrowLink: `Link naar andere kaarten`,
arrowGoal: `Stel een dagelijks beoordelingsdoel voor jezelf op`,
arrowDue: `Studiewoorden die moeten worden beoordeeld`,
arrowNew: `Studiekaarten die nog niet zijn beoordeeld`,
arrowMastered: `Als u geen verval of nieuwe kaarten hebt, kunt u mastered -kaarten bekijken om ze onder de knie te houden`,
arrowImport: `Importeer uw bestaande flashcards`,
arrowNewCard: `Voeg een nieuwe flashcards toe`,
dropboxStep1: `1. Krijg toegangscode van Dropbox door in te loggen`,
dropboxStep1Btn: `Log in met Dropbox`,
dropboxStep2: `2. Voer hieronder de toegangscode in`,
dropboxStep2Input: `Voer hier de code in`,
dropboxStep3: `3. Begin met synchroniseren`,
alreadyLinked: `Reeds gekoppeld, tik op om te ontkoppelen`,
selectCardsToLink: `Selecteer kaarten om te koppelen`,
unsupportedLangP: `Selecteer een taal die de uitspraak ondersteunt uit de instellingen van de set`,
links: `Links`,
emailUs: `Stuur ons een e-mail`,
whatsappUs: `Whatsapp ons`,
printMinHeight: `Min. rijhoogte`,
exportType: `Exporteer bestandstype`,
generateFileText: `Genereer bestand`,
generatatingFile: `Het genereren van bestand`,
verySmall: `Heel klein`,
small: `Klein`,
normal: `Normaal`,
big: `Groot`,
veryBig: `Erg groot`,
repeatNTimes: `Herhaal __ keer`,
pause: `Pauze`,
for: `voor`,
say: `Zeggen`,
defShort: `Defor.`,
times: `keer`,
autoplayPreferences: `Stel autoplay -voorkeuren in`,
autoPlay1: `Pauzeer na vorig woord`,
autoPlay2: `Aantal term uitspraak`,
autoPlay3: `Pauzeer voordat u de definitie onthult`,
autoPlay4: `Aantal definitieve uitspraken`,
autoPlay5: `Pauzeer voordat u het volgende woord weergeeft`,
autoPlay6: `Herhaal dezelfde flashcard`,
startAutoPlay: `Start autoplay`,
autoPlayOffConfirm: `Schakel AutoPlay uit om handmatige bedieningselementen in te schakelen`,
turnOff: `Uitschakelen`,
keepPn: `Behouden`,
foundIn: `Gevonden in __`,
repeat: `herhalen`,
stop: `Stop`,
listenInBreak: `Wist je dat? Je kunt in pauzes naar muziek / podcasts luisteren`,
contextSearch: `Context zoeken`,
contextSearchText: `Krijg voorbeelden van hoe __ wordt gebruikt in verschillende zinnen`,
transalteSearch: `Vertalen`,
translateSearchText: `Vertalen naar ___`,
synonymSearch: `Synoniem zoeken`,
synonymSearchText: `Zoek naar synoniemen van __`,
selectToAdd: `Selecteer de resultaten die u aan deze kaart wilt toevoegen`,
addToCard: `Voeg geselecteerd aan kaart toe`,
hideFromPractice: `Verbergen zich in de ronde`,
setLanguageRequired: `Selecteer de taal van de termen en definities in de studiesetgegevens`,
fieldNeedsText: `Voer iets in dit veld in voordat u zoekt`,
possibleDupe: `Mogelijk duplicaat`,
loadNextXCards: `Laad volgende __ kaarten`,
repeatPractice: `Herhaal deze __ kaarten`,
keepScreenOnInfo: `Mogelijk moet u uw Auto-Lock-instelling aanpassen, om het scherm aan te houden tijdens het autoplayen.`,
siteLoginH2: `SFM -account`,
siteLoginP: `U kunt uw flashcards -gemaakte account gebruiken om uw flashcards te delen met uw vrienden, uw studenten of de hele gemeenschap.`,
logOut: `Uitloggen`,
logIn: `Log in`,
createAccount: `Creëer een nieuw account`,
signUp: `Inschrijven`,
username: `Gebruikersnaam`,
email: `E -mail`,
password: `Wachtwoord`,
networkError: `Netwerkfout`,
fillAllDetails: `Vul alle details in`,
noUserWithDetails: `Geen gebruiker gevonden met de ingevoerde gegevens`,
userAlreadyExists: `De gegeven e -mail of gebruikersnaam bestaat al`,
signUpOrLoginToCont: `Meld u aan of log in om door te gaan?`,
atLeastOneCardToShare: `Er is ten minste één kaart nodig om te delen`,
publishingStudyset: `Publishing Studyset`,
updatesDetected: `Updates gedetecteerd, wilt u doorgaan met het bijwerken van lokale gegevens? (Verwijderd: __, bijgewerkt: ___, nieuw: ____)`,
updatesApplied: `Updates toegepast`,
alreadyUpToDate: `Al bijgewerkt`,
practiceTypeArrow: `Ontdek verschillende manieren van prijzen`,
share: `Delen`,
sharingModalIntro: `Deel je flashcards in deze set met je vrienden, je studenten of de hele gemeenschap.`,
whatIsShared: `Wat wordt gedeeld`,
whatIsNotShared: `Wat wordt niet gedeeld`,
whatIsSharedText: `Stel de naam in, set Term Language, Definiton -taal, alle opgenomen kaarten met termen, definities, aangepaste tekstvelden en afbeeldingen`,
whatIsNotSharedText: `Elke kaartsterkten, sterren, links, tags en uw beoordelingsgeschiedenis`,
checkForSharedUpdates: `Controleer op updates van Creator`,
fetchUpdates: `Updates ophalen`,
youSharedStudyset: `Je hebt dit studyset gedeeld`,
publishChanges: `Bewaar en publiceer wijzigingen`,
redeem: `Inwisselen`,
noAds: `Geen advertenties`,
dupeDetection: `Dubbele detectie`,
coffeeFeature: `Koffie, om ons te helpen meer functies te ontwikkelen`,
shareLink: `Deel link`,
coffeeForUs: `Je krijgt een levenslange licentie voor slechts __, die Emily 6 koffie, Dominik 3 koffie en Russ 3 koffie geeft, die ons ongeveer 39 uur zullen voeden om dit app -evenement beter te maken`,
sharingCards: `Kaarten delen`,
published: `Gepubliceerd`,
alreadyHaveAccount: `Heb je al een account?`,
notAlreadyHaveAccount: `Heb je nog geen account?`,
startPractice: `Begin met oefenen`,
selectQuizTypes: `Selecteer Quiz -typen`,
correct: `Juist`,
incorrect: `Niet correct`,
yes: `Ja`,
no: `Nee`,
levelSilver: `Zilverniveau __`,
levelGold: `Goudniveau __`,
levelPlatinum: `Platina niveau __`,
levelDiamond: `Diamantniveau __`,
levelJade: `Jade -niveau __`,
reviewsLeftGoal: `__ beoordelingen voor dagelijks doel`,
dailyGoalAchieved: `Dagelijks doel bereikt`,
share: `Delen`,
rateApp: `Beoordeel app`,
allStats: `Alle statistieken`,
reviewTimeError: `Time -out na fout`,
reviewTimeCorrect: `Time -out na correct`,
pronounceTermAfterReview: `Spreek de term uit na beoordeling`,
pronounceDefinitionAfterReview: `Definitie na beoordeling uitspreken`,
practice: `Oefening`,
notificationsScheduledInfo: `__ Meldingen zijn gepland, u kunt de app nu sluiten`,
wellDone: `Goed gedaan`,
keepItUp: `Ga zo door`,
youRock: `Jij rockt`,
niceOne: `Goed zo`,
lnSelect: `Selecteer taal`,
sampleData: `Geen beoordelingen, die voorbeeldgegevens weergeven`,
reviewFreq: `Bekijk de frequentie`,
selectPractice: `Oefening: selecteren`,
spellPractice: `Oefening: spellen`,
connectPractice: `Oefen: verbinding maken`,
languages: `Talen`,
languagesPairs: `Taalparen`,
shareArrow: `Deel set met vrienden, studenten of de hele gemeenschap`,
cardsPerRound: `Kaarten / ronde`,
showAll: `Toon alles`,
supportedLangsVary: `Ondersteunde talen variëren`,
practiceWithoutSave: `Oefen niet opgeslagen`,
practiceWithoutSaveBody: `Je hebt dit Studyset niet aan je verzameling toegevoegd, wil je het nu toevoegen om je studievoortgang op te slaan?`,
saveSetNow: `Bewaar kaarten voor uw collectie`,
continueWithoutSaveSave: `Begin met oefenen zonder opslaan`,
createdBy: `Gemaakt door`,
setSavedToYourCollection: `Studieset opgeslagen in uw verzameling`,
accountBackupDisclaimer: `Houd er rekening mee dat dit account alleen kan worden gebruikt voor het delen van Studysets met anderen en niet kan worden gebruikt om een ​​back -up te maken of te synchroniseren van uw studysets of flashcards. Gebruik Dropbox Sync om al uw gegevens te synchroniseren en te back -up`,
syncEnabled: `Synchronisatie ingeschakeld, uw inhoud in uitvoering ophalen`,
searchAllSets: `Zoekstudiesets van andere gebruikers`,
anyLanguage: `Elke taal`,
trendingIn: `Trending`,
manualBackups: `Handmatige back -up`,
manualBackupCreate: `Maak een handmatige back -up`,
confirmManualImport: `Weet u zeker dat u alle huidige gegevens wilt vervangen door deze back -up? Dit wordt alleen aanbevolen op nieuwe apparaten zonder gegevens`,
importFromManualBackup: `Importeren vanuit een back -up`,
imgOfflineSets: `Auto-downloadafbeeldingen voor offline leren`,
unsupportedDeviceCache: `Deze functie is alleen beschikbaar bij de iOS- of Android -app`,
shareChanges: `Deel __ wijzigingen`,
publiclySearchable: `Zoekbaar door gebruikers`,
description: `Beschrijving`,
restoreFromDropboxBackup: `Herstel vanaf Dropbox -back -up`,
imageCacheStudysetSub: `[IOS & Android alleen] Download afbeelding voor offline studeren`,
keywordsOrLangNeeded: `U moet enkele trefwoorden invoeren, of één taal`,
dropboxAlreadyLinked: `Dropbox -account is al gekoppeld`,
noSetUpdateAccess: `Je hebt geen toegang om deze studieset te bewerken.`,
confirmSetOwnerLogin: `Als u zeker weet dat u de eigenaar bent, probeer dan opnieuw in te loggen bij uw account.`,
uninitedRestriction: `Om uw voortgang op te slaan, moet u eerst dit Studyset toevoegen aan uw collectie`,
getStartedHere: `Get Started Here`,
downloadFromAppStore: `Download From AppStore`,
downloadFromGooglePlay: `Download From GooglePlay`,
consolidateStorageError: `Kan opslag niet consolideren`,
consolidateStorageDone: `Opslagconsolidatie, houd tot een uur voor Dropbox om oude bestanden te verwijderen voordat u zich aanmeldt op een nieuw apparaat.`,
consolidatingStorage: `Consolidatieopslag ...`,
deleteAccount: `Account verwijderen`,
consolidateStorageDescription: `Deze bewerking zal uw back -upbestanden opnieuw indexeren, dus het instellen van een nieuwe apparaten zal sneller zijn`,
consolidatingStorageConfirm: `Zorg ervoor dat al uw wijzigingen al zijn voltooid, synchroniseer geen andere apparaten terwijl dit proces plaatsvindt. Wil je doorgaan?`,
consolidateStorage: `Consolideer opslag`,


}